import AuthManager from "Common/AuthManager"
import ServiceWrapper from "Services/ServiceWrapper"
import AppSettings from "Settings/AppSettings"

export const refreshBuilderApi = async (builderId: string): Promise<any> => {
    const res = await ServiceWrapper.doGet(
        AppSettings.GMS_BACKEND_API_URL + `builder/${builderId}/refresh`,
        null,
        null,
        AuthManager.getGmsToken()
    );

    if (res.errorfound || !res.data.data) {
        throw new Error("Could not fetch category");
    }

    return res.data.data[0];
};